module.exports = __webpack_public_path__ + "fonts/Lora-Bold--755b0d247421de7700dd580f3c5dc7d3.755b0d247421de7700dd580f3c5dc7d3.woff";